/* unplugin-vue-components disabled */import { ElDialog as __unplugin_components_7 } from 'element-plus/es';import 'element-plus/es/components/dialog/style/css';
import { ElIcon as __unplugin_components_6 } from 'element-plus/es';import 'element-plus/es/components/icon/style/css';
import __unplugin_components_5 from '~icons/ep/check';
import { ElDatePicker as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/date-picker/style/css';
import { ElForm as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElButton as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElInput as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import { ElFormItem as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, isRef as _isRef, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7f998f8f"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 1
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tips"
}, "登录名可以通过玩家反馈的信息没在查询系统中获取，格式为U******A", -1));
const _hoisted_3 = ["onClick"];
import { apiUsdkMidstOrderList, apiUsdkMidstQuery } from '@/api/usdk';
import { useAppStore } from '@/store/modules/app';
import CTable from '@ultra/share/components/CTable/index.vue';
import dayjs from 'dayjs';
import { apiInternalRepairOrder } from '@/api/customerInternal';
export default /*#__PURE__*/_defineComponent({
  __name: 'iosMidst',
  setup(__props) {
    const useApp = useAppStore();
    const gameInfo = computed(() => useApp.gameInfo);
    const thirdOrderNum = ref('');
    const tableLoading = ref(false);
    const tableLoading2 = ref(false);
    const dialogLoading = ref(false);
    const tableData = ref([]);
    const tableData2 = ref([]);
    const activeOrderItem = ref({});
    const activeRadio = ref({});
    const visible = ref(false);
    const dialogForm = ref({
      // gid: 1016,
      gid: gameInfo.value.Id,
      loginName: '',
      date: ''
    });
    const columns = [{
      label: '小票号码',
      prop: 'thirdOrderNum',
      isDefault: true
    }, {
      label: '第三方平台订单号',
      prop: 'purchaseDate',
      isDefault: true
    }, {
      label: '档位',
      prop: 'productId',
      isDefault: true
    }, {
      label: '订单环境',
      prop: 'environment',
      isDefault: true
    }, {
      label: '平台订单号',
      prop: 'cmgeOrderNum',
      isDefault: true
    }, {
      label: '状态',
      prop: 'status',
      slot: 'status',
      isDefault: true
    }, {
      label: '操作',
      prop: 'action',
      slot: 'action',
      isDefault: true
    }];
    const columns2 = [{
      label: '操作',
      prop: 'action',
      slot: 'action',
      isDefault: true,
      width: 60
    }, {
      label: 'ID',
      prop: 'id',
      isDefault: true
    }, {
      label: '登录名',
      prop: 'loginName',
      isDefault: true
    }, {
      label: '平台订单号',
      prop: 'cmgeOrderNum',
      isDefault: true
    }, {
      label: '下单时间',
      prop: 'submitTimeStr',
      isDefault: true
    }, {
      label: '产品名称',
      prop: 'productName',
      isDefault: true
    }, {
      label: '提交金额',
      prop: 'submitAmount',
      isDefault: true
    }, {
      label: '成交金额',
      prop: 'dealAmount',
      isDefault: true
    }];
    const queryMidstOrder = async () => {
      console.log(gameInfo.value);
      let params = {
        thirdOrderNum: thirdOrderNum.value,
        gid: gameInfo.value.Id,
        cids: 8
        // gid: 1000
      };
      tableLoading.value = true;
      let res = await apiUsdkMidstQuery(params).finally(() => {
        tableLoading.value = false;
      });
      if (res.code != 0) return;
      tableData.value = res.data;
    };
    const onShowOrder = item => {
      console.log(item);
      activeOrderItem.value = item;
      visible.value = true;
    };
    const onQueryOrderByUser = async () => {
      console.log(dialogForm.value);
      let {
        date
      } = dialogForm.value;
      let params = {
        ...dialogForm.value,
        startDate: date && date.length ? dayjs(date[0]).format('YYYY-MM-DD hh:mm:ss') : undefined,
        endDate: date && date.length ? dayjs(date[1]).format('YYYY-MM-DD hh:mm:ss') : undefined
      };
      console.log(params);
      tableLoading2.value = true;
      let res = await apiUsdkMidstOrderList(params).finally(() => tableLoading2.value = false);
      if (res.code != 0) return;
      tableData2.value = res.data;
    };
    // 补单
    const onOk = async () => {
      const params = {
        id: activeRadio.value.id,
        transactionId: activeRadio.value.transactionId
      };
      dialogLoading.value = true;
      let res = await apiInternalRepairOrder(params).finally(() => dialogLoading.value = false);
      if (res.code != 0) return;
      visible.value = false;
    };
    return (_ctx, _cache) => {
      const _component_el_form_item = __unplugin_components_0;
      const _component_el_input = __unplugin_components_1;
      const _component_el_button = __unplugin_components_2;
      const _component_el_form = __unplugin_components_3;
      const _component_u_card_pane = _resolveComponent("u-card-pane");
      const _component_el_date_picker = __unplugin_components_4;
      const _component_i_ep_Check = __unplugin_components_5;
      const _component_el_icon = __unplugin_components_6;
      const _component_el_dialog = __unplugin_components_7;
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_u_card_pane, {
        name: "iosMidst"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form, {
          inline: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "玩家属性:"
          }, {
            default: _withCtx(() => [_createTextVNode(" 国内玩家 ")]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "小票号码:"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(thirdOrderNum),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(thirdOrderNum) ? thirdOrderNum.value = $event : null),
              clearable: "",
              placeholder: "请输入小票号码"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              onClick: queryMidstOrder
            }, {
              default: _withCtx(() => [_createTextVNode("查询")]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(CTable, {
          isCustomHeader: false,
          loading: _unref(tableLoading),
          "table-columns": columns,
          tableData: _unref(tableData),
          pagination: ""
        }, {
          status: _withCtx(({
            scope
          }) => {
            var _scope$row, _scope$row2;
            return [_createTextVNode(_toDisplayString((scope === null || scope === void 0 ? void 0 : (_scope$row = scope.row) === null || _scope$row === void 0 ? void 0 : _scope$row.status) === 0 ? '已掉单' : (scope === null || scope === void 0 ? void 0 : (_scope$row2 = scope.row) === null || _scope$row2 === void 0 ? void 0 : _scope$row2.status) === 1 ? '未掉单' : '-'), 1)];
          }),
          action: _withCtx(({
            scope
          }) => [(scope === null || scope === void 0 ? void 0 : scope.row.status) === 0 ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            plain: "",
            size: "small",
            type: "primary",
            onClick: $event => onShowOrder(scope === null || scope === void 0 ? void 0 : scope.row)
          }, {
            default: _withCtx(() => [_createTextVNode(" 补单 ")]),
            _: 2
          }, 1032, ["onClick"])) : (_openBlock(), _createElementBlock("div", _hoisted_1, "-"))]),
          _: 1
        }, 8, ["loading", "tableData"])]),
        _: 1
      }), _createVNode(_component_el_dialog, {
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _isRef(visible) ? visible.value = $event : null),
        "close-on-click-modal": false,
        title: "补单",
        width: "800px"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          loading: _unref(dialogLoading),
          type: "primary",
          onClick: onOk
        }, {
          default: _withCtx(() => [_createTextVNode("确认补单")]),
          _: 1
        }, 8, ["loading"])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          inline: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "玩家登录名"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(dialogForm).loginName,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(dialogForm).loginName = $event),
              placeholder: "请输入玩家的登录名"
            }, null, 8, ["modelValue"]), _hoisted_2]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "下单时间:"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_date_picker, {
              modelValue: _unref(dialogForm).date,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(dialogForm).date = $event),
              "end-placeholder": "结束时间",
              "range-separator": "至",
              "start-placeholder": "开始时间",
              type: "daterange"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              onClick: onQueryOrderByUser
            }, {
              default: _withCtx(() => [_createTextVNode("搜索")]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(CTable, {
          isCustomHeader: false,
          loading: _unref(tableLoading2),
          "table-columns": columns2,
          tableData: _unref(tableData2),
          pagination: ""
        }, {
          action: _withCtx(({
            scope
          }) => [_createElementVNode("div", {
            class: _normalizeClass([_unref(activeRadio).id === (scope === null || scope === void 0 ? void 0 : scope.row.id) ? "active" : "", "radio-box"]),
            onClick: $event => activeRadio.value = scope === null || scope === void 0 ? void 0 : scope.row
          }, [_unref(activeRadio).id === (scope === null || scope === void 0 ? void 0 : scope.row.id) ? (_openBlock(), _createBlock(_component_el_icon, {
            key: 0
          }, {
            default: _withCtx(() => [_createVNode(_component_i_ep_Check)]),
            _: 1
          })) : _createCommentVNode("", true)], 10, _hoisted_3)]),
          _: 1
        }, 8, ["loading", "tableData"])]),
        _: 1
      }, 8, ["modelValue"])], 64);
    };
  }
});